import { Input, InputNumber, Radio } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import * as Utils from "../utils/utils";

type TypeReturnPaymentItem = {
    isExist: boolean;
    item: Types.RentPaymentItemDto;
    adjusted: boolean;
    basicAmount: number;
    managerAmount: number;
    amount: number;
    memo?: string;
};

function ReturnAddDelayedArrivePaymentItem() {
    const params = useParams();
    const navigate = useNavigate();

    const [currentRentId, setCurrentRentId] = useState<number>();
    const [currentPaymentCategoryId, setCurrentPaymentCategoryId] = useState<number>();

    const [rent, setRent] = useState<Types.RentDto>();

    const [paymentCategory, setPaymentCategory] = useState<Types.RentPaymentCategoryDto>();
    const [paymentItemCheckList, setPaymentItemCheckList] = useState<Array<TypeReturnPaymentItem>>([]);

    const [paymentItemAddList, setPaymentItemAddList] = useState<Array<TypeReturnPaymentItem>>();

    useEffect(() => {
        if (params.rentId) setCurrentRentId(Number(params.rentId));
        if (params.categoryId) setCurrentPaymentCategoryId(Number(params.categoryId));
    }, [params]);

    useEffect(() => {
        // Utils.onEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);
        Utils.triggerEvent(Common.EVENT_ENABLE_PROCESS_BUTTON, true);

        currentRentId && requestGetRent();

        // return () => {
        //     Utils.offEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);
        // };
    }, [currentRentId]);

    useEffect(() => {
        setPaymentItemAddList(paymentItemCheckList.filter((check) => check.isExist === true));
    }, [paymentItemCheckList]);

    useEffect(() => {
        Utils.onEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);
        return () => {
            Utils.offEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);
        };
    }, [paymentItemAddList]);

    useEffect(() => {
        currentPaymentCategoryId && requestGetPaymentCategory();
    }, [currentPaymentCategoryId]);

    const requestAxiosGetRent = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_URL + currentRentId);
        return response.data;
    };

    const { loading: loadingGetRent, error: errorGetRent, data: resultGetRent, execute: requestGetRent } = useAsyncAxios(requestAxiosGetRent);

    useEffect(() => {
        if (resultGetRent === null) return;
        console.log("resultGetRent", resultGetRent);
        setRent(resultGetRent.rent);
    }, [resultGetRent]);

    useEffect(() => {
        if (errorGetRent === null) return;
        console.log("errorGetRent", errorGetRent);
    }, [errorGetRent]);

    const requestAxiosGetPaymentCategory = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_PAYMENT_CATEGORY_URL + "/" + currentPaymentCategoryId);
        return response.data;
    };

    const {
        loading: loadingGetPaymentCategory,
        error: errorGetPaymentCategory,
        data: resultGetPaymentCategory,
        execute: requestGetPaymentCategory,
    } = useAsyncAxios(requestAxiosGetPaymentCategory);

    useEffect(() => {
        if (resultGetPaymentCategory === null) return;
        console.log("resultGetPaymentCategory", resultGetPaymentCategory);
        setPaymentCategory(resultGetPaymentCategory.rentPaymentCategory);
    }, [resultGetPaymentCategory]);

    useEffect(() => {
        if (errorGetPaymentCategory === null) return;
        console.log("errorGetPaymentCategory", errorGetPaymentCategory);
    }, [errorGetPaymentCategory]);

    useEffect(() => {
        if (paymentCategory === undefined || rent === undefined) return;

        paymentCategory && Utils.triggerEvent(Common.EVENT_SET_HEADER_TITLE, paymentCategory.rentPaymentCategoryName);

        // init
        const tempItemCheckList: TypeReturnPaymentItem[] = [];
        paymentCategory?.rentPaymentItems?.forEach((paymentItem) =>
            tempItemCheckList.push({
                isExist: false,
                item: paymentItem,
                adjusted: false,
                basicAmount: Utils.getPaymentItemAmount(rent, paymentItem),
                managerAmount: 0,
                amount: Utils.getPaymentItemAmount(rent, paymentItem),
            })
        );

        setPaymentItemCheckList(tempItemCheckList);
    }, [paymentCategory, rent]);

    const goToNextProcess = () => {
        // setPaymentItemAddList(paymentItemCheckList.filter((check) => check.isExist === true));
        if (paymentItemAddList === undefined) return;

        if (paymentItemAddList.length === 0) {
            navigate(Common.PAGE_RETURN_CHECKLIST + "/" + currentRentId);
        } else {
            saveAddPaymentItem();
        }
    };

    // useEffect(() => {
    //     if (paymentItemAddList === undefined) return;

    //     if (paymentItemAddList.length === 0) {
    //         navigate(Common.PAGE_RETURN_CHECKLIST + "/" + currentRentId);
    //     } else {
    //         saveAddPaymentItem();
    //     }
    // }, [paymentItemAddList]);

    const saveAddPaymentItem = () => {
        if (paymentItemAddList === undefined) return;

        const tempAddItems = [...paymentItemAddList];
        const addItem = tempAddItems.shift();

        setPaymentItemAddList(tempAddItems);

        if (addItem) {
            requestAddPayment(addItem);
        } else {
            navigate(Common.PAGE_RETURN_CHECKLIST + "/" + currentRentId);
        }
    };

    const requestAxiosAddPayment = async (item: TypeReturnPaymentItem) => {
        const payment: any = {
            rent: { rentId: currentRentId },
            rentPaymentType: "PENALTY",
            rentPaymentItem: item.item,
            basicPrice: item.basicAmount,
            paymentMethod: "OFFLINE_BANK",
            adjustedPrice: 0,
            amount: item.amount,
        };
        if (item.adjusted) payment.adjustedPrice = item.managerAmount - item.basicAmount;
        if (item.memo) payment.memo = item.memo;

        const response = await utilAxiosWithAuth().post(Request.RENT_PAYMENT_ADD_URL, payment);
        return response.data;
    };

    const {
        loading: loadingAddPayment,
        error: errorAddPayment,
        data: resultAddPayment,
        execute: requestAddPayment,
    } = useAsyncAxios(requestAxiosAddPayment);

    useEffect(() => {
        if (resultAddPayment === null) return;
        console.log("resultAddPayment", resultAddPayment);
        saveAddPaymentItem();
        // rent !== undefined && requestGetRentInfo();
    }, [resultAddPayment]);

    useEffect(() => {
        if (errorAddPayment === null) return;
        console.log("errorAddPayment", errorAddPayment);
    }, [errorAddPayment]);

    const onChangeExist = (rentPaymentItemId: number, checked: boolean) => {
        const tempCheckList = [...paymentItemCheckList];
        const tempItem = tempCheckList.find((item) => item.item.rentPaymentItemId === rentPaymentItemId);
        tempItem && (tempItem.isExist = checked);

        setPaymentItemCheckList(tempCheckList);
    };

    const onChangeAdjusted = (rentPaymentItemId: number, checked: boolean) => {
        const tempCheckList = [...paymentItemCheckList];
        const tempItem = tempCheckList.find((item) => item.item.rentPaymentItemId === rentPaymentItemId);
        if (tempItem) {
            tempItem.adjusted = checked;
            if (checked === true) {
                tempItem.amount = tempItem.managerAmount;
            } else {
                tempItem.amount = tempItem.basicAmount;
            }
        }

        setPaymentItemCheckList(tempCheckList);
    };

    const onChangeAdjustedAmount = (rentPaymentItemId: number, amount: number | null) => {
        if (amount === null) return;

        const tempCheckList = [...paymentItemCheckList];
        const tempItem = tempCheckList.find((item) => item.item.rentPaymentItemId === rentPaymentItemId);
        if (tempItem) {
            tempItem.managerAmount = amount;
            if (tempItem.adjusted === true) {
                tempItem.amount = amount;
            }
        }

        setPaymentItemCheckList(tempCheckList);
    };

    const onChangeMemo = (rentPaymentItemId: number, memo: string | null) => {
        if (memo === null) return;

        const tempCheckList = [...paymentItemCheckList];
        const tempItem = tempCheckList.find((item) => item.item.rentPaymentItemId === rentPaymentItemId);
        if (tempItem) {
            tempItem.memo = memo;
        }
    };

    // useEffect(() => {
    //     console.log("paymentItemCheckList", paymentItemCheckList);
    // }, [paymentItemCheckList]);

    const displayPaymentItems = () => {
        return paymentItemCheckList.length > 0
            ? paymentItemCheckList.map((check) => {
                  return (
                      <div key={check.item.rentPaymentItemId}>
                          <h3>{check.item.rentPaymentItemName}</h3>
                          <div>
                              <Radio.Group onChange={(e) => onChangeAdjusted(check.item.rentPaymentItemId, e.target.value)} value={check.adjusted}>
                                  <Radio value={false}>{Utils.convertCurrencyKorean(check.basicAmount)}</Radio>
                                  <Radio value={true}>
                                      <InputNumber
                                          disabled={!check.adjusted}
                                          value={check.managerAmount}
                                          onChange={(value) => onChangeAdjustedAmount(check.item.rentPaymentItemId, value)}
                                      ></InputNumber>
                                  </Radio>
                              </Radio.Group>
                              {/* <Input value={check.memo} onChange={(e) => onChangeMemo(check.item.rentPaymentItemId, e.target.value)}></Input> */}
                          </div>
                      </div>
                  );
              })
            : null;
    };

    return <div>{displayPaymentItems()}</div>;
}

export default ReturnAddDelayedArrivePaymentItem;
